export const DEFAULT_OAUTH_CALLBACK_URL =
  'https://api.instantdb.com/runtime/oauth/callback';

export const GOOGLE_AUTHORIZATION_ENDPOINT =
  'https://accounts.google.com/o/oauth2/v2/auth';
export const GOOGLE_TOKEN_ENDPOINT = 'https://oauth2.googleapis.com/token';
export const GOOGLE_DISCOVERY_ENDPOINT =
  'https://accounts.google.com/.well-known/openid-configuration';

export const APPLE_AUTHORIZATION_ENDPOINT =
  'https://appleid.apple.com/auth/authorize';
export const APPLE_TOKEN_ENDPOINT = 'https://appleid.apple.com/auth/token';
export const APPLE_DISCOVERY_ENDPOINT =
  'https://appleid.apple.com/.well-known/openid-configuration';

export const LINKEDIN_AUTHORIZATION_ENDPOINT =
  'https://www.linkedin.com/oauth/v2/authorization';
export const LINKEDIN_TOKEN_ENDPOINT =
  'https://www.linkedin.com/oauth/v2/accessToken';
export const LINKEDIN_DISCOVERY_ENDPOINT =
  'https://www.linkedin.com/oauth/.well-known/openid-configuration';
